import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../buttons';
import { HeroComponent } from './components';

@NgModule({
    imports: [
        CommonModule,

        ButtonModule,
    ],
    declarations: [
        HeroComponent,
    ],
    exports: [
        HeroComponent,
    ],
})

export class HeroModule {}
